import { forwardRef, useState } from "react";
import {
    Box,
    Dialog,
    Divider,
    Slide,
    Typography
} from "@mui/material";
import { styled } from '@mui/system';

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const MyDivider = styled('div')`
    border-top: 1px dashed black;
`;

function Receipt( props ) {
    const { receiptOpen, setReceiptOpen, data, setData } = props;

    const closeClick = () => {
        setReceiptOpen(false);
    }

    return (
        <>
            <Dialog fullScreen open={receiptOpen} onClose={closeClick} TransitionComponent={Transition}>
                <Box
                    sx={{
                        width: '90%',
                        textAlign: 'left',
                        padding: '30px 0 10px 10px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start'
                    }}>
                    <img src='/img/back_button_black.png' onClick={closeClick} />
                    <Box
                        sx={{
                            paddingTop: 2,
                            margin: '0 auto',
                            fontSize: '22px'
                        }}>
                        신용카드 매출전표
                    </Box>
                </Box>
                <Divider />
                <Box
                    sx={{
                        // background: '#f1f2f2',
                        margin: '20px',
                        padding: '20px',
                        borderRadius: '5px',   
                        border: 1,                     
                    }}>

                    <Box><Typography fontSize={14} fontWeight="bold">결제금액</Typography></Box>                    
                    <Box marginTop={0.5}></Box>                    
                    <Divider color="black"></Divider>

                    <Box marginTop={2.1}></Box>                    
                    <Box display="flex">
                        <Box><Typography fontSize={14} fontWeight="bold">총결제금액</Typography></Box>
                        <Box flex="1" textAlign="right"><Typography fontWeight="bold" fontSize={14}>{data.amount}원</Typography></Box>
                    </Box>
                    <Box marginTop={2.1}></Box>     
                    <MyDivider></MyDivider>                                   
                    
                    <Box marginTop={2.1}></Box>     
                    <Box display="flex">
                        <Box><Typography fontSize={14}>공급가액</Typography></Box>
                        <Box flex="1" textAlign="right"><Typography fontSize={14}>{data.supply}원</Typography></Box>
                    </Box>
                    <Box display="flex">
                        <Box><Typography fontSize={14}>부가세</Typography></Box>
                        <Box flex="1" textAlign="right"><Typography fontSize={14}>{data.vat}원</Typography></Box>
                    </Box>
                    <Box display="flex">
                        <Box><Typography fontSize={14}>합게</Typography></Box>
                        <Box flex="1" textAlign="right"><Typography fontSize={14}>{data.amount}원</Typography></Box>
                    </Box>

                    <Box marginTop={2.1}></Box>     
                    <Box><Typography fontSize={14} fontWeight="bold">결제정보</Typography></Box>                    
                    <Box marginTop={0.5}></Box>                    
                    <Divider color="black"></Divider>

                    <Box marginTop={2.1}></Box>                    
                    <Box display="flex">
                        <Box><Typography fontSize={14}>구매자명</Typography></Box>
                        <Box flex="1" textAlign="right"><Typography fontSize={14}>{data.buyer_name}</Typography></Box>
                    </Box>
                    <Box display="flex">
                        <Box><Typography fontSize={14}>카드종류</Typography></Box>
                        <Box flex="1" textAlign="right"><Typography fontSize={14}>{data.card_name}</Typography></Box>
                    </Box>                    
                    <Box display="flex">
                        <Box><Typography fontSize={14}>카드번호</Typography></Box>
                        <Box flex="1" textAlign="right"><Typography fontSize={14}>{data.card_number}</Typography></Box>
                    </Box>
                    <Box display="flex">
                        <Box><Typography fontSize={14}>거래유형</Typography></Box>
                        <Box flex="1" textAlign="right"><Typography fontSize={14}>{data.status}</Typography></Box>
                    </Box>
                    <Box display="flex">
                        <Box><Typography fontSize={14}>결제승인번호</Typography></Box>
                        <Box flex="1" textAlign="right"><Typography fontSize={14}>{data.apply_num}</Typography></Box>
                    </Box>
                    <Box display="flex">
                        <Box><Typography fontSize={14}>할부개월</Typography></Box>
                        <Box flex="1" textAlign="right"><Typography fontSize={14}>{data.card_quota}</Typography></Box>
                    </Box>
                    <Box display="flex">
                        <Box><Typography fontSize={14}>상품명</Typography></Box>
                        <Box flex="1" textAlign="right"><Typography fontSize={14}>{data.name}</Typography></Box>
                    </Box>
                    <Box display="flex">
                        <Box><Typography fontSize={14}>결제일시</Typography></Box>
                        <Box flex="1" textAlign="right"><Typography fontSize={14}>{data.paid_at}</Typography></Box>
                    </Box>
                    
                    <Box marginTop={2.1}></Box>     
                    <Box><Typography fontSize={14} fontWeight="bold">거래처정보</Typography></Box>                    
                    <Box marginTop={0.5}></Box>                    
                    <Divider color="black"></Divider>

                    <Box marginTop={2.1}></Box>     
                    <Box display="flex">
                        <Box><Typography fontSize={14}>업체명</Typography></Box>
                        <Box flex="1" textAlign="right"><Typography fontSize={14}>{data.company}</Typography></Box>
                    </Box>                    
                    <Box display="flex">
                        <Box><Typography fontSize={14}>업체주소</Typography></Box>
                        <Box textAlign="right" flex="1"><Typography fontSize={14}>{data.addr}</Typography></Box>
                    </Box>                    
                    <Box display="flex">
                        <Box><Typography fontSize={14}>사업자번호</Typography></Box>
                        <Box flex="1" textAlign="right"><Typography fontSize={14}>{data.company_no}</Typography></Box>
                    </Box>                    
                    <Box display="flex">
                        <Box><Typography fontSize={14}>연락처</Typography></Box>
                        <Box flex="1" textAlign="right"><Typography fontSize={14}>{data.tel}</Typography></Box>
                    </Box>    
                    <Box display="flex">
                        <Box><Typography fontSize={14}>대표자명</Typography></Box>
                        <Box flex="1" textAlign="right"><Typography fontSize={14}>{data.head}</Typography></Box>
                    </Box>                                     
                    
                </Box>    
            </Dialog>
            
        </>
    )
}

export default Receipt;